import React from 'react';
import './index.scss';

const DotSlider = ({ items, onChange }) => {
  return (
    <div className="DotSlider">
      <div className="slide-wrapper">
        <div className="slider" data-slide-length={items.length}>
          {items.map(item => {
            return (
              <span key={item.id}>
                <input type="radio" id={item.value} value={item.value} onChange={onChange} checked={item.checked} required />
                <label htmlFor={item.value} data-label={item.label}></label>
              </span>
            );
          })}
        </div>
      </div>
    </div>

  );
};

export default DotSlider;